import Service from '../Service'

export default class FechamentoMesService extends Service{

    constructor(){
        super('fechamentomes');
    }
  
  }